var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 133,
    viewBox: "0 0 133 133",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atom/bouton/delete",
    transform: "translate(-9.000000, -6.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.3813953,72.8125 C50.455814,72.8125 51.3348837,71.95 51.3348837,70.8958333 L51.3348837,50.7708333 C51.3348837,49.7166667 50.455814,48.8541667 49.3813953,48.8541667 C48.3069767,48.8541667 47.427907,49.7166667 47.427907,50.7708333 L47.427907,70.8958333 C47.427907,71.9979167 48.3069767,72.8125 49.3813953,72.8125 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,72.8125 C58.0744186,72.8125 58.9534884,71.95 58.9534884,70.8958333 L58.9534884,50.7708333 C58.9534884,49.7166667 58.0744186,48.8541667 57,48.8541667 C55.9255814,48.8541667 55.0465116,49.7166667 55.0465116,50.7708333 L55.0465116,70.8958333 C55.0465116,71.9979167 55.9255814,72.8125 57,72.8125 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6186047,72.8125 C65.6930233,72.8125 66.572093,71.95 66.572093,70.8958333 L66.572093,50.7708333 C66.572093,49.7166667 65.6930233,48.8541667 64.6186047,48.8541667 C63.544186,48.8541667 62.6651163,49.7166667 62.6651163,50.7708333 L62.6651163,70.8958333 C62.6651163,71.9979167 63.544186,72.8125 64.6186047,72.8125 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0465116,41.7625 L66.1813953,41.7625 L64.9604651,37.7375 C64.3255814,35.6770833 62.372093,34.2395833 60.1744186,34.2395833 L53.8255814,34.2395833 C51.627907,34.2395833 49.6744186,35.6770833 49.0395349,37.7375 L47.8186047,41.7625 L37.9534884,41.7625 C36.8790698,41.7625 36,42.625 36,43.6791667 C36,44.7333333 36.8790698,45.5958333 37.9534884,45.5958333 L39.4674419,45.5958333 L39.4674419,75.1604167 C39.4674419,77.7 41.5674419,79.8083333 44.2046512,79.8083333 L69.844186,79.8083333 C72.4325581,79.8083333 74.5813953,77.7479167 74.5813953,75.1604167 L74.5813953,45.5479167 L76.0465116,45.5479167 C77.1209302,45.5479167 78,44.6854167 78,43.63125 C78,42.5770833 77.1209302,41.7625 76.0465116,41.7625 Z M52.8,38.8395833 C52.9465116,38.4083333 53.3372093,38.0729167 53.8255814,38.0729167 L60.2232558,38.0729167 C60.7116279,38.0729167 61.1023256,38.3604167 61.2488372,38.8395833 L62.127907,41.7625 L51.872093,41.7625 L52.8,38.8395833 Z M70.6255814,75.1125 C70.6255814,75.54375 70.2348837,75.9270833 69.7953488,75.9270833 L44.2046512,75.9270833 C43.7651163,75.9270833 43.3744186,75.54375 43.3744186,75.1125 L43.3744186,45.5479167 L70.6744186,45.5479167 L70.6744186,75.1125 L70.6255814,75.1125 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trash.eef1383ed3560e1f3d863150ba1df4d5.svg";